import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'cn',
    conver: 'zh-CN',
    alia: 'zh',
    region: 'China',
    regionText: '中国（大陆）',
    language: 'Chinese',
    languageText: '简体中文',
    appId: 10,
    acceptLanguage: 'zh-CN,zh;q=0.9',
};
export default theLocale;
